import React, { useState } from "react";
import { Dimensions, Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { ApplicationPendingBlockedStatus, ApplicationPendingContext, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, ImageSizeTokens, TextAlignTokens, } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Button } from "../../button/Button";
import { Image } from "../../image/Image";
import { Typography } from "../../typography/Typography";
const ApplicationPendingBlockedPage = ({ height, state, title, subtitle, contactUsAction, logoutAction, triggerAction, context, btnTitle, action, disableCta }) => {
    const [_context, setContext] = useState(context ? context : ApplicationPendingContext.DEFAULT);
    const [_disableCta, setDisableCta] = useState(disableCta ? disableCta : false);
    const onPressContactUs = () => {
        contactUsAction &&
            triggerAction(contactUsAction);
    };
    const onPress = () => {
        action &&
            triggerAction(action);
    };
    const onPressLogout = () => {
        logoutAction &&
            triggerAction(logoutAction);
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    height: state === ApplicationPendingBlockedStatus.BLOCKED ? height - 72 : height - 124,
                    padding: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                state === ApplicationPendingBlockedStatus.BLOCKED ?
                    (React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details.png', width: 164, height: 164 })) : (context !== ApplicationPendingContext.DEFAULT)
                    ? (React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/system_Error1.png', width: 64, height: 64 })) : (React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/warning.png', width: 64, height: 64 })),
                React.createElement(View, { style: { height: 16 } }),
                React.createElement(Typography, { label: `${title}`, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', textAlign: TextAlignTokens.center, lineHeight: 24, color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: { height: 16 } }),
                React.createElement(View, { style: {
                        padding: 8,
                        borderRadius: 6,
                        width: '100%',
                        backgroundColor: '#FFF6DD'
                    } },
                    React.createElement(Typography, { label: `${subtitle}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', textAlign: TextAlignTokens.center, lineHeight: 20, color: ColorTokens.Grey_Night })))));
    };
    const _footerChild = () => {
        if (context !== ApplicationPendingContext.DEFAULT) {
            return (React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 16,
                } },
                !_disableCta && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: `${btnTitle}`, type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            onPress();
                        } }),
                    React.createElement(View, { style: { height: 24 } }))),
                React.createElement(View, { style: {
                        width: '100%'
                    } },
                    React.createElement(TouchableOpacity, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }, onPress: () => onPressContactUs() },
                        React.createElement(Typography, { label: 'Need help? ', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 24 }),
                        React.createElement(Typography, { label: 'Contact us', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 24, color: ColorTokens.Primary_100 })))));
        }
        switch (state) {
            case ApplicationPendingBlockedStatus.DENIED:
                return (React.createElement(View, { style: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 16,
                    } },
                    React.createElement(Button, { label: 'Need help? Contact us', type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            onPressContactUs();
                        } }),
                    React.createElement(View, { style: { height: 12 } }),
                    React.createElement(Button, { label: 'Logout', type: ButtonTypeTokens.LargeSoftFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            onPressLogout();
                        } })));
                break;
            case ApplicationPendingBlockedStatus.BLOCKED:
                return (React.createElement(View, { style: {
                        width: '100%',
                    } },
                    React.createElement(View, { style: {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 16
                        } },
                        React.createElement(Button, { label: 'Need help? Contact us', type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                                onPressContactUs();
                            } }))));
                break;
        }
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 15 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: [styles.body, { height: height }] }, _bodyChild()),
            React.createElement(View, { style: styles.footer }, _footerChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    body: {},
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        width: '100%',
    },
});
export default (ApplicationPendingBlockedPage);
